import { grey } from '@mui/material/colors';

export const Divider = {
  MuiDivider: {
    styleOverrides: {
      root: {
        borderColor: grey[300],
      },
    },
    variants: [
      {
        props: { variant: 'mediumGrey' },
        style: {
          borderColor: grey[400],
        },
      },
    ],
  },
};
